import React, {useEffect, useState} from "react";
import './mobarchiveli.css';
import { AnimatePresence, easeOut, motion} from 'framer-motion';

const MobArchiveListItem = ({item, activeIdx, isInFilter, handleMobLiClick, idx, mobileElementRefs, isColourMode}) => {
    const [runTimeString, setRunTimeString] = useState(null);

    useEffect(() => {
        try{
            if(item.meta){
                let firstPrepend = '';
                
                if(item.meta.runTime[0]<10)
                    firstPrepend = '0'
                let secondPrepend = ''
                if(item.meta.runTime[1]<10)
                    secondPrepend = '0'

                let tmpNew = firstPrepend+item.meta.runTime[0]+":"+secondPrepend+item.meta.runTime[1];
                setRunTimeString(tmpNew)
            }
        } catch{}
    }, [item])

    return (
        <motion.div
            key={"mob_list_item_"+idx}
            className={`mob_archv_li`}
            ref={el => mobileElementRefs.current[idx] = el}
            onClick={()=>handleMobLiClick(idx)}
            style={{
                opacity: isInFilter ? 1 : 0.25,
                pointerEvents: !isInFilter ? "none" : null
            }}
        >
            <motion.div className="mob_li_content padding_1">
                <div>
                    <motion.span initial={{
                        transform: "translate3d(0,100%,0)",
                        opacity: 0,
                    }}
                        animate={{
                            transform: "translate3d(0,0%,0)",
                            opacity: 1,
                            transition: {
                                delay: 0.25 + 0.025*idx,
                                duration: 1.5,
                                ease: [0.16, 1, 0.3, 1]
                            }
                        }}
                        exit={{
                            transform: "translate3d(0,100%,0)",
                            transition: {
                                duration: 0.75,
                                delay: 0.025 * idx,
                                ease: [0.76, 0, 0.24, 1]
                            }                        
                        }}>
                        {idx < 9 ? '0' : ''}{idx+1}
                    </motion.span>
                </div>
                <div>
                    <motion.span
                        className="pt"
                        key={"mob_li_"+idx}
                        initial={{
                            transform: "translate3d(0,100%,0)",
                            opacity: 0,
                        
                        }}
                        animate={{
                            transform: "translate3d(0,0%,0)",
                            opacity: 1,
                            transition: {
                                delay: 0.25 + 0.025 + 0.025*idx,
                                duration: 1.5,
                                ease: [0.16, 1, 0.3, 1]
                            }
                        }}
                        exit={{
                            transform: "translate3d(0,100%,0)",
                            transition: {
                                duration: 0.75,
                                delay: 0.025 * idx,
                                ease: [0.76, 0, 0.24, 1]
                            }                        
                        }}
                        >
                            '{item.title}'
                    </motion.span>
                </div>
                <div className="an">
                    <motion.span
                        key={"mob_li_artist"+idx}
                        initial={{
                            transform: "translate3d(0,100%,0)",
                            opacity: 0,
                        }}
                        animate={{
                            transform: "translate3d(0,0%,0)",
                            opacity: 1,
                            transition: {
                                delay: 0.25 + 0.035 + 0.025*idx,
                                duration: 2,
                                ease: [0.16, 1, 0.3, 1]
                            }
                        }}
                        exit={{
                            transform: "translate3d(0,100%,0)",
                            transition: {
                                duration: 0.75,
                                delay: 0.025 * idx,
                                ease: [0.76, 0, 0.24, 1]
                            }                        
                        }}
                        >
                            {item.artist}
                        </motion.span>
                </div>
                <div className="rt">
                    <motion.span 
                        initial={{
                            transform: "translate3d(0,100%,0)",
                            opacity: 0
                        }}
                        animate={{
                            transform: "translate3d(0,0%,0)",
                            opacity: 1,
                            transition: {
                                delay: 0.25 + 0.045 + 0.025*idx,
                                duration: 1.5,
                                ease: [0.16, 1, 0.3, 1]
                            }
                        }}
                        exit={{
                            transform: "translate3d(0,100%,0)",
                            transition: {
                                duration: 0.75,
                                delay: 0.025 * idx,
                                ease: [0.76, 0, 0.24, 1]
                            }                        
                        }}>
                        <div key={runTimeString}>{runTimeString}</div>
                    </motion.span>
                </div>
            </motion.div>
        </motion.div>
    )
}

export default MobArchiveListItem;